export const SERVICE_NAMES = {
  CO_AUTHOR: 'Co-Author'
} as const; 